import apiZelo from '../../../services/backAxiosVendaToken';

export const buscaNomeCemiterio = async subGrupo => {
    const data = await apiZelo.get(`/associados/cemiterios-planos/${subGrupo}`);

    return data.data;
};
